export default __webpack_public_path__ + "static/media/8.e3519b1e.jpg";